import {CreditCardType} from "../../types/credit-card"

export const verificationNumberLength = (type: Nullable<CreditCardType>): number => {
    return type === CreditCardType.AMEX ? 4 : 3
}
